import { Container, Grid, StyledGrid } from "@animech/ui";
import styled from "@emotion/styled";

export const Root = styled(Container)``;

export const DimensionInputRoot = styled(Grid)`
	${StyledGrid.Item} {
		align-content: center;
	}
`;
